import "./Popup.css";
import { Modal } from "react-bootstrap";

const Popup = ({ show, handleClose, title, titleStyle, body, bodyStyle, footer, footerStyle, size }) => {
  return (
    <div className="popup">
      <Modal size={ size ? size : ''} show={show} onHide={handleClose} centered scrollable>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body className={bodyStyle}>
          
          <Modal.Title className={titleStyle}>
            {title}
          </Modal.Title>
          {body}
        </Modal.Body>
        <Modal.Footer className={footerStyle}>
          {footer}
        </Modal.Footer>
      </Modal>
    </div>
    
  );
};

export default Popup;
